module.exports = __webpack_public_path__ + "img/swiper_3.5_5_2.894e170c.webp";